export default class Notification {
  constructor (initialData = {},) {
    const {
      _id,
      name,
      type,
      status,
      category,
      content,
      descriptor,
      schedule,
      sent_at,
      target,
      created_at,
      created_by,
      updated_at,
    } = initialData;

    this._id = _id;
    this.name = name;
    this.type = type;
    this.status = status;
    this.category = category;
    this.content = content;
    this.descriptor = descriptor;
    this.start_date = schedule.start_date;
    this.end_date = schedule.end_date;
    this.sent_at = sent_at;
    this.target = target;
    this.created_at = created_at;
    this.created_by = created_by;
    this.updated_at = updated_at;
  }

  set notification (notification,) {
    this._id = notification._id;
    this.name = notification.name;
    this.type = notification.type;
    this.status = notification.status;
    this.category = notification.category;
    this.content = notification.content;
    this.descriptor = notification.descriptor;
    this.start_date = notification.schedule.start_date;
    this.end_date = notification.schedule.end_date;
    this.sent_at = notification.sent_at;
    this.target = notification.target;
    this.created_at = notification.created_at;
    this.created_by = notification.created_by;
    this.updated_at = notification.updated_at;
  }
}
